import React from "react";
import { useSelector } from "react-redux";
import InsuranceList from "../../../../components/cases/assets/balanceOfAssets/insurance";

const Insurance = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <InsuranceList next={next} back={back} updates={updates} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="Insurance"
        setVisited={visited}
      /> */}
    </>
  );
};

export default Insurance;
